import { Box, styled, useTheme } from '@mui/material';
import { Link } from 'react-router-dom';
import RotoGPTLogo from './RotoGPT.png';
const LogoWrapper = styled(Link)(
  ({ theme }) => `
        color: ${theme.palette.text.primary};
        display: flex;
        text-decoration: none;
        width: 80px;
        font-weight: ${theme.typography.fontWeightBold};
`
);

function Logo() {
  const theme = useTheme();

  return (
    <LogoWrapper to="/home">
      <img src={RotoGPTLogo} style={{ width: '90px' }} alt="RotoGPT logo" />
    </LogoWrapper>
  );
}

export default Logo;
